import { render, staticRenderFns } from "./CreateServiceSkeleton.vue?vue&type=template&id=957e0b46&scoped=true"
import script from "./CreateServiceSkeleton.vue?vue&type=script&lang=js"
export * from "./CreateServiceSkeleton.vue?vue&type=script&lang=js"
import style0 from "./CreateServiceSkeleton.vue?vue&type=style&index=0&id=957e0b46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "957e0b46",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
installComponents(component, {VSkeletonLoader})
